import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { NewsLayoutComponent } from './news.layout';
import { OtherNewsListComponent } from './other-news-list/other-news-list.component';
import { SingleNewsComponent } from './single-news/single-news.component';
import { SingleNewsLayoutComponent } from './single-news/single-news.layout';

const routes: Routes = [
  {
    // Everything inherited (in Children) will be one column layout WITH Sidebar
    path: '',
    component: NewsLayoutComponent,

    children: [
      {
        path: 'latest',
        component: ListComponent,
      },
      {
        path: 'communityUpdates',
        component: OtherNewsListComponent
      },
      {
        path: 'productUpdates',
        component: OtherNewsListComponent
      },
      {
        path: 'partnership',
        component: OtherNewsListComponent
      },
      {
        path: 'learn',
        component: OtherNewsListComponent
      },
      {
        path: 'staking',
        component: OtherNewsListComponent
      }


    ]
  },
  {
    // Everything inherited (in Children) will be one column layout  
    path: '',
    component: SingleNewsLayoutComponent,
    children: [
      {
        path: 'single/:id',
        component: SingleNewsComponent
      }
    ]

  } 
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewsRoutingModule { }
